import { useEffect, useState, useRef, Check } from 'react'
import ButtonControl from "../../../Controls/ButtonControl"
import Button from 'react-bootstrap/Button';
import { useNavigate } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import { toast } from 'react-toastify';
import "../../../assets/css/ShowFiles.css"
import GridControl from "../../../Controls/GridControl"
import {
    GetLocal,
    SetLocal,
    FetchService,
    GetParamsUrl,

} from "../../../Base/BaseControl";

export default function Index(props) {
    let fileNumber = 0;
    let regionCode = 0;
    const [getServiceResult, setServiceResult] = useState(false);

    const navigate = useNavigate();

    useEffect(() => {
        if (GetParamsUrl("id")) {
            var inputValue = {
                nationalCode: GetParamsUrl("id"),
                IsEncrypt: true
            };
            FetchService("Owner/Residential/Request/ShowFileNumberList", inputValue, ShowFileNumberListSuccess);
        }

    }, []);

    const ShowFileNumberListSuccess = (ServiceResult) => {
        setServiceResult(ServiceResult.FileNumberListInfo);
    }

    const OpenFile = (row) => {
        getServiceResult && GetSessionByFileNumber(row)
    }

    const GetSessionByFileNumber = (row) => {
        fileNumber = row.FileNumber;
        regionCode = row.RegionCode;

        var inputValue = {
            //session: GetLocal('OwnersSession'),
            fileNumber: row.FileNumber,
            regionCode: row.RegionCode,

        };
        FetchService("Owner/Residential/Security/GetSessionByFileNumber", inputValue, GetSessionByFileNumberSuccess);
    };

    const GetSessionByFileNumberSuccess = (serviceResult) => {
        SetLocal('OwnersFileNumber', fileNumber);
        SetLocal('OwnersSession', serviceResult.SessionValue);
        navigate("/ShowReviewDetail?page=نمایش گزارش بازدید");
        //window.location.href = "/Home";
    }

    const DataGrid = () => {
        return (
            <GridControl
                data={getServiceResult}
                customHeaders={{ "FileNumber": "شماره پرونده", "Address": "آدرس", "Plate": "پلاک ثبتی", "RenovationCode": "کد نوسازی", "OpenFile": "نمایش" }}
                OpenFile={OpenFile}
            />
        )
    }

    return (
        <div id="bgShowFile">
            <div className="main">
                <div className="formShowFile">
                    <h5>لیست پرونده ها:</h5><br />
                    <DataGrid />
                </div>
            </div>
        </div>
    );
}